import dev from './config.dev.json';
import prod from './config.prod.json';

interface IBankConfig {
  bank: string;
  domain: string;
  cssFileAddress: string;
  language: string;
  fullPage: boolean;
  tagsConstraints: string[];
  keyDocuments: string[];
  otherDocuments: string[];
}

const defaultConfig: IBankConfig = {
  bank: 'default bank',
  domain: '',
  cssFileAddress: 'bib-hbl.css',
  language: 'hbl',
  fullPage: false,
  tagsConstraints: ['Constraint:YES'],
  keyDocuments: ['FIDLEG-BIB'],
  otherDocuments: ['KIID', 'KIDforPRIIP', 'Factsheet', 'Prospectus', 'AnnualReport', 'SemiAnnualReport']
}

let config = [] as IBankConfig[];

switch (process.env.NODE_ENV) {
  case 'production':
    config = prod;
    break;
  case 'development':
    config = dev;
    break;
}

export default config.find(
  (bankConfig) => bankConfig.domain === window.location.hostname
) || defaultConfig;
